import React, { useRef } from "react";
import { View, StyleSheet } from "react-native";
import NtListRow from "../../components/NtListRow";
import NtModal from "../../components/NtModal";
import NtBadge from "../../components/NtBadge";
import NtNumberManageForm from "./NtNumberManageForm";
import NtAccountDisplay from "./NtAccountDisplay";
import { formatTelephoneNumber } from "../utils/numberUtils";

function NtNumberItem({ item, columns, canEdit = true, onUpdate, onDelete }) {
  const manageModalRef = useRef();

  return (
    <View style={styles.container}>
      <NtListRow
        item={item}
        columns={columns}
        renderCustom={(row, column) => {
          // Return plain strings for text cells so NtListRow wraps them in a
          // themed NtText (color: theme.text). Returning a bare <NtText> here
          // would bypass that and render in NtText's static (non-themed) color.
          if (column === "did") {
            return formatTelephoneNumber(row.did);
          }
          if (column === "description") {
            return row.routeDescription || "—";
          }
          if (column === "route") {
            if (!row.routeAction) {
              return "—";
            }
            const disabled = row.routeEnabled === false;
            return (
              <View style={styles.routeCell}>
                <View style={disabled ? styles.routeDimmed : null}>
                  <NtAccountDisplay item={row.routeAction} />
                </View>
                {disabled ? <NtBadge variant="red">Disabled</NtBadge> : null}
              </View>
            );
          }
        }}
        onActionPress={
          canEdit ? () => manageModalRef.current?.show() : null
        }
      />
      <NtModal ref={manageModalRef}>
        <NtNumberManageForm
          item={item}
          onCancel={() => manageModalRef.current?.dismiss()}
          onUpdate={() => {
            manageModalRef.current?.dismiss();
            if (onUpdate) onUpdate();
          }}
          onDelete={() => {
            manageModalRef.current?.dismiss();
            if (onDelete) onDelete();
          }}
        />
      </NtModal>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
  routeCell: { flexDirection: "row", alignItems: "center", gap: 8, flexWrap: "wrap" },
  routeDimmed: { opacity: 0.5 },
});

export default NtNumberItem;
